export default "__VITE_ASSET__DZxpXTBT__"